export function chordDistanceToDegrees(distance: number): number {
  const clamped = Math.min(Math.max(distance, 0), 2);
  return 2 * Math.asin(clamped / 2) * (180 / Math.PI);
}

export function isBlinkSentinel(distance: number): boolean {
  return distance < 0;
}
